/** CRM e UF separados, prontos para consultar a foto do médico. */
export interface CrmUf {
    crm: number;
    uf: string;
}

/**
 * Separa um `crmUf` no formato `1348698-RJ`. Quando o valor não traz a UF, cai na UF recebida como
 * segundo argumento (o protocolo carrega a UF do CRM em campo próprio).
 *
 * Devolve `null` quando falta CRM numérico ou UF — sem os dois não há consulta a fazer, e um
 * `parseInt` de `'ABC'` viraria `NaN` na URL.
 */
export function separarCrmUf(crmUf?: string, ufAlternativa?: string): CrmUf | null {
    const texto = (crmUf ?? '').trim();
    if (!texto) {
        return null;
    }

    const partes = texto.split('-');
    const crmTexto = partes.length === 2 ? partes[0].trim() : texto;
    const uf = (partes.length === 2 ? partes[1].trim() : (ufAlternativa ?? '')).trim();

    const crm = parseInt(crmTexto, 10);
    if (Number.isNaN(crm) || !uf) {
        return null;
    }

    return { crm, uf };
}
